export const setWarrantyData = (data) => ({
  type: 'SET_WARRANTY_DATA',
  payload: data,
});
